const getAbsoluteHeight = el => {
  // Get the DOM Node if you pass in a string
  // eslint-disable-next-line no-param-reassign
  el = typeof el === 'string' ? document.querySelector(el) : el;

  const styles = window.getComputedStyle(el);
  const margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);

  return Math.ceil(el.offsetHeight + margin);
};
export default getAbsoluteHeight;



// WEBPACK FOOTER //
// ./src/scripts/util/absoluteHeight.js